<template>
<div class="containerWrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <form>
          <vue-form-generator :schema="objectSchema" :model="objectModel" />
        </form>
      </div>
    </div>
  </div>
  <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <Button  label="Spara" class="p-button-success" @click="onSave()" icon="pi pi-check" ></Button>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import VueFormGenerator from 'vue-form-generator'
import Button from 'primevue/button'
export default {
  name: 'ObjectDataCreate',
  components: {
    Button,
    'vue-form-generator': VueFormGenerator.component
  },
  data () {
    return {
      objectGroupId: 0,
      objectDescriptionId: 0,
      objectModel: {},
      objectSchema: {}
    }
  },
  props: {
    groupId: 0,
    descriptionId: 0,
    model: {},
    schema: {}
  },
  watch: {
    model: function (newVal, oldVal) {
      this.objectModel = this.$props.model
    },
    schema: function (newVal, oldVal) {
      this.objectSchema = this.$props.schema
      this.objectSchema.fields.push({
        type: 'submit',
        buttonText: 'Save',
        onSubmit: this.onSave
      })
    },
    groupId: function (newVal) {
      this.objectGroupId = newVal
    },
    descriptionId: function (newVal) {
      this.objectDescriptionId = newVal
    }
  },
  async created () {
    this.objectModel = this.$route.params.model
    this.objectSchema = this.$route.params.schema
    this.objectGroupId = this.$route.params.groupId
    this.objectDescriptionId = this.$route.params.descriptionId
    await this.doAPICalls()
  },
  methods: {
    onSave () {
      var url = '/api/objectdatas'
      this.$http
        .post(url, {
          objectdata: {
            objectGroupId: this.objectGroupId,
            objectDescriptionId: this.objectDescriptionId,
            ...{
              data: this._.omit(this.objectModel, 'submit')
            }
          }
        })
        .then(response => {
          this.$router.push('/ObjectDataList/' + this.$route.params.objectDataListId)
        })
        .catch(error => console.log(error))
    },
    onCancel () {
      this.$router.push('/ObjectDataList/' + this.$route.params.objectDataListId)
    },
    async doAPICalls () {
      for (const v of this.objectSchema.objectProps.getExternal) {
        const data = await this.$http.get(v.api)
        let field = this.objectSchema.fields.find(f => f.model === v.model)
        for (let d of data.data) {
          field[v.ref].push({ value: d.id, name: d.data.name })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectData/ObjectDataCreate.vue